import React, { useState } from 'react';
import { FileInput as RAFileInput, FileField, useInput } from 'react-admin';
import { Button, Box } from '@mui/material';
import useOneDriveSDK from './OneDrive'; // Custom hook to load SDK
import { downloadCloudFile } from '../../framework/utils/cloudFileProxy';

const FileInput = (props) => {
    const { source } = props;
    const { field } = useInput(props);
    const [cloudFiles, setCloudFiles] = useState([]);
    
    // Debug logging
    console.log('FileInput field.value:', field.value);
    console.log('FileInput props:', props);

   // useOneDriveSDK(); // Load the OneDrive SDK


    const openMicrosoftFilePicker = () => {
        const oneDrive = (window as any).OneDrive;

        if (!oneDrive) {
            console.error('OneDrive SDK not loaded');
            return;
        }

        const odOptions = {
            clientId: "5e5a1298-2562-4b01-bc6c-486ee3ee5508",
            action: "query",
            multiSelect: true,
            accessToken: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJadVFxM0dKZ21qdjREQkhuYXl2MmR1SVNvajFjN0ZQTGJiZmtUaXFnd09vIn0.eyJleHAiOjE3MzcwNjAwMTUsImlhdCI6MTczNzA1OTcxNSwiYXV0aF90aW1lIjoxNzM3MDU5NDI2LCJqdGkiOiJiZTBjNjNhNy1hZDNlLTQwODUtYTI4NS1kZjdlNzZiYTc2NTAiLCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjgwODAvcmVhbG1zL2NjLXRyaWFsIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6ImZkMDRkOTdhLTY3YTYtNDdiOC1iOTdlLWI4Zjk0YjJkNDAwOSIsInR5cCI6IkJlYXJlciIsImF6cCI6IjVlNWExMjk4LTI1NjItNGIwMS1iYzZjLTQ4NmVlM2VlNTUwOCIsInNpZCI6ImYyNDI2ZjNhLWUyNjktNDA2Mi05OWZkLTIxZGJlMzU3ZmUyYSIsImFjciI6IjAiLCJhbGxvd2VkLW9yaWdpbnMiOlsiaHR0cDovL2xvY2FsaG9zdDo1MTczIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJkZWZhdWx0LXJvbGVzLWNjLXRyaWFsIiwib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGVtYWlsIHByb2ZpbGUiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IkphY2sgS2VubmVkeSIsInByZWZlcnJlZF91c2VybmFtZSI6ImphY2sua2VubmVkeUBtYWRtb2JpbGUub3JnIiwiZ2l2ZW5fbmFtZSI6IkphY2siLCJmYW1pbHlfbmFtZSI6Iktlbm5lZHkiLCJlbWFpbCI6ImphY2sua2VubmVkeUBtYWRtb2JpbGUub3JnIn0.DvI8_MsmBU5T9N-0H-tVWBJrMh41dU8TxNw19yU9gCPDWtwtW5RWIi2xzQN3EsJ1rJCD6Fn4HAj7qzmb-hmDHPG8t1YVPmrAQJX5eORVTnasS0PEppUlKxjtp2M50X5tPFBTZOAe9LUuyq7wy6JlhcZnwpO4bq6nAy3KAitGyrHXi7SdCgR33BBeCVp6esqVyh3xiIR04jGRNDbWRR3KcFT5MnWSlLjMUx3WxPjEmqjRIlX_OpkozdS3GiKH6m5MD56AkKg6w1I595ABu6MjoUHyey1Eym87LJjufU-dfbmcNtpiQyD41gJYkO3U4b_bKgHkylaXYIWFBryKybboYA'
            ,advanced: {
                redirectUri: "http://localhost:5173",
            },
            success: async function (selectedFiles) {
                console.log("selectedFiles", selectedFiles);
                console.log("First file structure:", selectedFiles.value[0]); // Debug the actual structure
                
                // Load file content immediately and treat as local files
                const formattedFiles = await Promise.all(
                    selectedFiles.value.map(async (file, index) => {
                        console.log("Processing file:", file);
                        
                        // Extract available information from the picker response
                        const fileId = file.id;
                        const driveId = file.parentReference?.driveId;
                        const endpoint = file.endpoint;
                        
                        // Generate a meaningful name if possible, otherwise use index
                        let fileName = `SharePoint File ${index + 1}`;
                        
                        // Try to extract file name from ID or other properties if available
                        if (file.name) fileName = file.name;
                        else if (file.displayName) fileName = file.displayName;
                        else if (file.title) fileName = file.title;
                        else if (file.fileName) fileName = file.fileName;
                        
                        // Try multiple download URL approaches
                        const downloadUrls = [
                            // Use picker-provided download URL first (if available)
                            file.downloadUrl,
                            file.link,
                            // Fallback to Graph API content endpoint
                            `${endpoint}/drives/${driveId}/items/${fileId}/content`
                        ].filter(Boolean);
                        
                        try {
                            // Use server-side proxy to download the file (bypasses CORS)
                            let downloadResult;
                            let lastError;
                            
                            // Try each URL until one works
                            for (const downloadUrl of downloadUrls) {
                                try {
                                    console.log(`Trying download URL via server proxy: ${downloadUrl}`);
                                    downloadResult = await downloadCloudFile({
                                        downloadUrl: downloadUrl,
                                        accessToken: odOptions.accessToken,
                                        fileName: fileName
                                    });
                                    
                                    console.log(`Success with URL: ${downloadUrl}`);
                                    break;
                                } catch (error) {
                                    console.log(`Error with URL ${downloadUrl}:`, error);
                                    lastError = error;
                                    continue;
                                }
                            }
                            
                            if (!downloadResult) {
                                throw lastError || new Error('All download URLs failed');
                            }
                            
                            // Server already returns base64 data
                            const base64Data = downloadResult.base64Data;
                            
                            // Convert base64 back to blob for rawFile compatibility
                            const response = await fetch(base64Data);
                            const blob = await response.blob();
                            
                            return {
                                id: fileId,
                                // React-admin FileField expects these specific properties
                                title: downloadResult.fileName || fileName,
                                src: base64Data, // Now contains actual file content
                                // Create a fake rawFile for compatibility with existing processing
                                rawFile: new File([blob], downloadResult.fileName || fileName, { 
                                    type: downloadResult.contentType || 'application/octet-stream' 
                                }),
                                // Mark as originally from OneDrive but now treated as local
                                originalSource: 'onedrive',
                                source: 'local', // Treat as local for processing
                                type: downloadResult.contentType || 'application/octet-stream'
                            };
                        } catch (error) {
                            console.error(`Failed to download file ${fileName}:`, error);
                            
                            // Fallback to reference if download fails
                            const fileUrl = file.link || file.webUrl || file.downloadUrl ||
                                           `${endpoint}/drives/${driveId}/items/${fileId}`;
                            
                            return {
                                id: fileId,
                                title: fileName,
                                src: fileUrl,
                                name: fileName,
                                url: fileUrl,
                                driveId: driveId,
                                endpoint: endpoint,
                                sharePointId: file.sharePoint?.uniqueId,
                                type: file.mimeType || 'application/octet-stream',
                                source: 'onedrive',
                                downloadError: true
                            };
                        }
                    })
                );
                
                console.log("Formatted files:", formattedFiles);
                setCloudFiles((prevFiles) => [...prevFiles, ...formattedFiles]);
                
                // Merge with existing files - react-admin style
                const currentFiles = field.value || [];
                const allFiles = [...currentFiles, ...formattedFiles];
                console.log("Current files:", currentFiles);
                console.log("Adding cloud files:", formattedFiles);
                console.log("Total files:", allFiles);
                
                field.onChange(allFiles);
            },
            cancel: function () {
                console.log("Cloud file selection canceled");
            },
            error: function (error) {
                console.error("Error during file selection:", error);
            },
        };

        oneDrive.open(odOptions); // Open Microsoft OneDrive picker
    };

    return (
        <Box>
            {/* Original FileInput functionality - configured for multiple files */}
            <RAFileInput {...props} multiple>
                <FileField source="src" title="title" />
            </RAFileInput>
            


            {/* Button to trigger cloud file picker */}
            <Button
                variant="contained"
                color="primary"
                onClick={openMicrosoftFilePicker}
                style={{ marginTop: 10 }}
            >
                Select Files from Cloud
            </Button>
        </Box>
    );
};

export default FileInput;